<template>
  <header>
    <!-- .header-content .row -->
    <div class="header-content row">
      <!-- .header-logo -->
      <p class="header-logo"><router-link to="/corp_admin/user"><img src="/corp_admin/static/logo.png" alt="食のトレンド情報Web"></router-link></p>
      <h1>法人会員専用 管理画面</h1>
      <nav>
        <ul>
          <li><router-link v-on:click.native="logout()" to="/corp_admin/login">ログアウト</router-link></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import store from '../store'
export default {
  methods: {
    async logout () {
      store.dispatch('logout')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue